import IconHandshake, {
	IconHandshakeProps as _IconHandshakeProps,
} from './IconHandshake';

export { IconHandshake };
export type IconHandshakeProps = _IconHandshakeProps;
